export default __webpack_public_path__ + "static/media/location.1f043909.png";